import dynamic from 'next/dynamic';

export const SearchResultPageRecommendationsDynamic = dynamic(
  () =>
    import(
      /* webpackChunkName: 'SearchResultPageRecommendations' */ './SearchResultPageRecommendations'
    ).then((mod) => mod.SearchResultPageRecommendations),
  { ssr: false },
);
